import React, { useCallback, useState } from 'react'

import { Link } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import DocumentNavigatorCompatible from 'modules/documents/components/DocumentNavigator/Compatible'
import type { NavigatorContentProps } from 'modules/documents/components/DocumentPreview'
import DocumentPreview from 'modules/documents/components/DocumentPreview'
import type Document from 'modules/documents/store/models/Document'

import styles from './index.module.scss'

interface Props {
  readonly?: boolean
  document: Document
  contractVersions: ContractVersions
}

const DocumentItem: React.FC<Props> = ({ readonly = false, document, contractVersions }) => {
  const [preview, setPreview] = useState(false)

  const onDeleteDocument = useCallback(async () => {
    asyncAction(() => document.destroy())
  }, [document])

  const onPreviewDocument = useCallback(() => {
    setPreview(true)
  }, [])

  const onClosePreview = useCallback(() => {
    setPreview(false)
  }, [])

  const renderPreview = useCallback(
    (navigatorProps: NavigatorContentProps) => {
      return <DocumentPreview {...navigatorProps} contractVersions={contractVersions} />
    },
    [contractVersions]
  )

  const renderNavigator = () => {
    if (!preview) return null

    return (
      <DocumentNavigatorCompatible
        documentIds={[document.id]}
        index={0}
        onClose={onClosePreview}
        content={renderPreview}
        contractVersions={contractVersions}
      />
    )
  }

  return (
    <div className={styles.documentItem}>
      {renderNavigator()}
      <div className={styles.name}>{document.attributes.filename}</div>
      <div className={styles.controls}>
        <ul className={styles.controlsList}>
          <li className={styles.item}>
            <Link.Touchable onClick={onPreviewDocument}>
              {i18n.t('common.view_document')}
            </Link.Touchable>
          </li>
          {!readonly && (
            <li className={styles.item}>
              <Link.Touchable onClick={onDeleteDocument}>{i18n.t('common.remove')}</Link.Touchable>
            </li>
          )}
        </ul>
      </div>
    </div>
  )
}

export default observer(DocumentItem)
